{"errno":-2,"code":"ENOENT","syscall":"open","path":"/tmp/tmp-147699qB2IyLDQ7yzT/packages/auth/dist/[synthetic:es6/util/makeiterator]"}